import fitvids from 'fitvids';
fitvids();